<template>
  <div class="wrapper bg-login-main">
    <div class="m-account-w">
      <div class="m-account">
        <div class="row no-gutters">
          <div class="col-md-6">
            <div
              class="m-account--content-w bg-login-right"
              data-bg-img="assets/images/account/bg-login-data.jpg"
            >
              <div class="m-account--content">
                <h2 class="h2">{{ $t("LOGIN.NAO_TEM_CONTA") }}</h2>
                <div @click="abrirCadastro" class="btn btn-cadastro">
                  {{ $t("LOGIN.CADASTRAR_USUARIO") }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="m-account--form-w">
              <div class="m-account--form">
                <div class="logo">
                  <img src="../../assets/images/logo.png" alt="" />
                </div>
                <div class="m-account--title">
                  {{ $t("GERAL.SISTEMA_GESTAO_MSG") }}
                </div>

                <b-form @submit="login">
                  <p class="m-account--subtitle">
                    {{ $t("LOGIN.FACA_LOGIN") }}
                  </p>

                  <div class="form-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <i class="fa fa-user"></i>
                      </div>
                      <input-text
                        ref="nomeUsuario"
                        label="Usuario"
                        no-label
                        type="text"
                        name="username"
                        placeholder="Usuário ou E-mail"
                        autocomplete="off"
                        v-model="form.nomeUsuario"
                        required
                        class="input-user input-login"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <i class="fas fa-key"></i>
                      </div>
                      <input-text
                        ref="senha"
                        label="Senha"
                        no-label
                        type="password"
                        name="password"
                        placeholder="Senha"
                        autocomplete="off"
                        v-model="form.senha"
                        required
                        class="input-password"
                        :showPassword="true"
                      />
                      <div class="input-group-append" v-if="showPassword">
                        <span
                          class="input-group-text"
                          id="basic-addon2"
                          role="button"
                          @click="changePasswordField"
                        ></span>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="tokenRecaptcha"
                      @verify="onVerify"
                      @expired="onExpired"
                    />
                  </div>

                  <div class="m-account--actions">
                    <div @click="abrirEsqueceuASenha" class="btn-link">
                      {{ $t("LOGIN.ESQUECEU_SENHA") }}
                    </div>
                    <b-button
                      @click="login"
                      type="submit"
                      class="btn btn-primary"
                      >{{ $t("LOGIN.ENTRAR") }}</b-button
                    >
                  </div>

                  <div class="m-account--footer">
                    <p>
                      Powered By <span><a href="#">Jordão Energia</a></span>
                    </p>
                  </div>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import InputText from "@/components/inputs/InputText";
import { LOGIN } from "@/store/autenticacao.module";
import Swal from "sweetalert2";
import { VueRecaptcha } from "vue-recaptcha";
import { TOKEN_RECAPTCHA } from "@/config/config";

export default {
  name: "Login",
  components: {
    InputText,
    VueRecaptcha,
  },
  data() {
    return {
      form: {
        nomeUsuario: null,
        senha: null,
      },
      mostrarModal: false,
      showPassword: false,
      recaptchaResponse: null,
    };
  },
  computed: {
    tokenRecaptcha() {
      return TOKEN_RECAPTCHA;
    },
  },
  methods: {
    onVerify(response) {
      this.recaptchaResponse = response;
    },
    onExpired() {
      this.recaptchaResponse = null;
    },
    abrirCadastro() {
      this.$router.push({ name: "Cadastro" });
    },
    abrirEsqueceuASenha() {
      this.$router.push({ name: "esqueceu-sua-senha" });
    },
    validarFormulario() {
      let arValidation = [];
      arValidation.push(this.$refs.nomeUsuario.valid());
      arValidation.push(this.$refs.senha.valid());
      return arValidation.filter((elem) => elem == false).length == 0;
    },

    AlternarPassword() {
      this.showPassword = !this.showPassword;
    },

    // Lógica do login com reCAPTCHA v3
    async login(e) {
      e.preventDefault();
      if (!this.validarFormulario()) return;

      if (!this.recaptchaResponse) {
        Swal.fire({
          title: this.$t("GERAL.ERRO"),
          text: "Por favor, verifique o reCAPTCHA.",
          icon: "error",
        });
        return;
      }

      this.$store.dispatch(START_LOADING);

      const form = { ...this.form }; // Inclui o token no envio

      // Envia o formulário com o token reCAPTCHA para o backend
      this.$store
        .dispatch(LOGIN, form)
        .then(() => {
          this.$store.commit("app/setSelectedCompany", null);
          localStorage.removeItem("selectedCompanyObj");
          localStorage.removeItem("selectedCompany");
          this.$router.push({ name: "dashboard" });
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    abrirModal() {
      this.mostrarModal = true;
    },
    fecharModal() {
      this.mostrarModal = false;
    },
  },
};
</script>

<style scoped>
.input-login {
  margin-right: auto;
}

.input-password {
  margin-right: auto;
}

.input-login .invalid-feedback {
  position: absolute;
  bottom: -20px;
}

.input-password .is-valid {
  max-width: 180px;
}
</style>
